export default __webpack_public_path__ + "static/feedback_avatar5-93f0e238c4e26ef41f7507c708112b2b.webp";